<mat-dialog-content>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col md:flex-row justify-start items-center">
      <span class="f-s-20">{{revocation.id === 0? 'Begin ' : 'Update '}}Training Program Resolution</span>
      <span class="flex-1"></span>
    </div>

    <form [formGroup]="revocationForm">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col md:flex-row gap-4 justify-start items-center">
          <span>Reason: {{revocation.reason}}</span>
        </div>
        <div class="flex flex-col md:flex-row gap-4">
          <div class="flex flex-col gap-4 w-full md:w-1/2">
            <span>Program Comments</span>
            <div [innerHtml]="revocation.programComments"></div>
            <mat-form-field>
              <textarea formControlName="programComments" matInput rows="3" placeholder="Update Comments" type="text">
              </textarea>
            </mat-form-field>
          </div>
          <div class="flex flex-col gap-2 w-full md:w-1/2">
            <span>Staff Comments</span>
            <div [innerHtml]="revocation.staffComments"></div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row gap-2">
          <button mat-stroked-button type="button" color="primary" (click)="submitRevocationComment()">Update</button>
          <button mat-stroked-button type="button" color="warn" (click)="cancel()">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
